import { createSlice, PayloadAction } from '@reduxjs/toolkit';

export interface PaymentPreprocessorState {
  status: boolean | null;
  error: string | null;
  data: Record<string, unknown> | null;
}

export const LEADER_IFRAME_BRIDGE_KEY = 'leaderIframeBridge';

export const initialPreprocessorResultState: PaymentPreprocessorState = {
  status: null,
  error: null,
  data: null,
};

export const leaderIframeBridgeSlice = createSlice({
  name: LEADER_IFRAME_BRIDGE_KEY,
  initialState: initialPreprocessorResultState,
  reducers: {
    resetPreprocessorData: (state) => {
      state.data = null;
    },
    requestFinteqHub: () => {},
    continueProcessing: (
      state,
      action: PayloadAction<Record<string, any>>,
    ) => {},
    setPreprocessorStatus: () => {},
  },
});

export const preprocessorReducer = leaderIframeBridgeSlice.reducer;

export const {
  resetPreprocessorData,
  requestFinteqHub,
  continueProcessing,
  setPreprocessorStatus,
} = leaderIframeBridgeSlice.actions;
